
export default {
    props: {
        bannerStyle: {
            type: Object,
            default: () => null
        }
    },

    created() {

    }
}
